import Select from "react-select";

function FiltersLabelPrompt({
  availableLabels,
  selectedLabel,
  setSelectedLabel,
  availablePrompts,
  selectedPrompt,
  setSelectedPrompt,
}) {
  return (
    <>
      <label>Filter by Label</label>
      <Select
        options={availableLabels}
        value={selectedLabel}
        onChange={setSelectedLabel}
        className="mb-3"
        isClearable
      />

      <label>Filter by Prompt</label>
      <Select
        options={availablePrompts}
        value={selectedPrompt}
        onChange={setSelectedPrompt}
        className="mb-3"
        isClearable
      />
    </>
  );
}

export default FiltersLabelPrompt;
